import { useRequest } from 'ahooks';
import { GetAISummarizeParamsProps } from '@/pages/aigc/service';
import http from '@/utils/http';
import { formattingFormData } from '../utils';
import { RequrstBack, } from '@/pages/aigc/types/server';
import { queryInitStatClientConfig } from '@/pages/aigc/constants/server';
// 获取数据表
export const useGetTableHome = <T, B = boolean>(params: T, stat: B) => {
  const fetch = (mutateParams: T) =>
    http({
      url: '/api/v1/ai2sql/get_game_all_tables',
      method: 'post',
      data: params,
      transformRequest: [
        (data: GetAISummarizeParamsProps) => formattingFormData(data)
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!stat && !!params,
    cacheKey: 'surfaceStructure',
    loadingDelay: 0,
    staleTime: 1000 * 60 * 3,
  });
  return {
    ...data,
  };
};

// 详情表格
export const useGetTableDetail = <T>(params?: T) => {
  const fetch = (mutateParams: T) => http({
    url: '/api/v1/ai2sql/get_table_detail',
    method: 'post',
    data: mutateParams,
    transformRequest: [
      (data: GetAISummarizeParamsProps) => formattingFormData(data)
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },

  }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    cacheKey: 'delStructure',
    loadingDelay: 0,
    manual: true,
  });
  return {
    ...data,
  };
};



